import { Col, Row, Table } from "antd";
import { get } from "lodash";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { MdOpenInNew, MdOutlineDeleteOutline } from "react-icons/md";
import { useNavigate } from "react-router-dom";

import Pagination from "shared/components/Pagination";
import Status from "shared/components/Status";
import { NAME_SPACES } from "shared/locales/constants";
import { COLORS } from "shared/style/colors";
import { DATE_FORMAT, SCREENS } from "utils/constants";

function List({ data, count, setValues, skip, setOpenDetail }) {
  const navigate = useNavigate();
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.DISCOUNT_CODE);
  const LIST = t("LIST", { returnObjects: true });

  const columns = [
    {
      title: LIST.CODE,
      dataIndex: "code",
      render: (record) => <Status text={record} status="black" />,
    },
    {
      title: LIST.LABEL,
      dataIndex: "label",
      render: (record) => record || "-",
    },
    {
      title: LIST.TARIFF_KEY,
      dataIndex: "tariffKey",
      render: (record) => record || "-",
    },
    {
      title: LIST.PROCESS,
      dataIndex: "process",
      render: (record) => get(record, "name", "-"),
    },
    {
      title: LIST.ACTIVE,
      dataIndex: "active",
      render: (record) => (
        <Status
          status={record ? "main" : "default"}
          text={record ? LIST.ACTIVE : LIST.INACTIVE}
        />
      ),
    },
    {
      title: LIST.START_DATE,
      dataIndex: "startDate",
      render: (record) => (record ? moment(record).format(DATE_FORMAT) : "-"),
    },
    {
      title: LIST.END_DATE,
      dataIndex: "endDate",
      render: (record) => (record ? moment(record).format(DATE_FORMAT) : "-"),
    },
    {
      title: LIST.ACTIONS,
      dataIndex: "id",
      align: "right",
      render: (id, row) => (
        <Row gutter={8} justify="end" align="center" wrap={false}>
          <Col onClick={() => setOpenDetail(row)}>
            <MdOpenInNew size={24} color={COLORS.C_PRIMARY} />
          </Col>
          <Col
            onClick={() =>
              navigate(
                `${SCREENS.PRIVATE.ADMIN.DISCOUNT_CODES.DELETE.path}/${id}`,
              )
            }
          >
            <MdOutlineDeleteOutline size={24} color={COLORS.C_DANGER} />
          </Col>
        </Row>
      ),
    },
  ];

  return (
    <>
      <Table
        dataSource={data}
        className="table__wrapper"
        columns={columns}
        rowKey={"id"}
        pagination={false}
        scroll={{ x: true }}
      />
      <Pagination count={count} setValues={setValues} skip={skip} />
    </>
  );
}

export default List;
